import { render, staticRenderFns } from "./programtv.vue?vue&type=template&id=ad1b07f2"
import script from "./programtv.vue?vue&type=script&lang=js"
export * from "./programtv.vue?vue&type=script&lang=js"
import style0 from "./programtv.vue?vue&type=style&index=0&id=ad1b07f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports